import PublicIcon from "@mui/icons-material/Public";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { RenderLink } from "../utils";

const REQUESTER_LINK = process.env.REACT_APP_PUBLIC_CONSTANT_FEATURE_LINK_REQUESTER || "https://requester.padme-analytics.de";
const STATION_REGISTRY_LINK = process.env.REACT_APP_PUBLIC_CONSTANT_FEATURE_LINK_STATION_REGISTRY || "https://station-registry.de";
const DEPOT_LINK = process.env.REACT_APP_PUBLIC_CONSTANT_FEATURE_LINK_DEPOT || "https://depot.padme-analytics.de";
const CREATOR_LINK = process.env.REACT_APP_PUBLIC_CONSTANT_FEATURE_LINK_CREATOR || "https://creator.padme-analytics.de";
const STOREHOUSE_LINK = process.env.REACT_APP_PUBLIC_CONSTANT_FEATURE_LINK_STOREHOUSE || "https://storehouse.padme-analytics.de";
const PLAYGROUND_LINK = process.env.REACT_APP_PUBLIC_CONSTANT_FEATURE_LINK_PLAYGROUND || "https://playground.padme-analytics.de";
const METADATA_DASHBOARD_LINK = process.env.REACT_APP_PUBLIC_CONSTANT_FEATURE_LINK_METADATA_DASHBOARD || "https://monitoring.padme-analytics.de";
const SCHEMA_LINK = process.env.REACT_APP_PUBLIC_CONSTANT_FEATURE_LINK_SCHEMA || "https://schema.padme-analytics.de";
const DOCUMENTATION_LINK = process.env.REACT_APP_PUBLIC_CONSTANT_FEATURE_LINK_DOCUMENTATION || "https://docs.padme-analytics.de";

const features = [
  {
    title: "Central Service Dashboard",
    description:
      "Here you can request new Trains and inspect the result of finished Trains.",
    label: "Visit the Train Requester",
    link: REQUESTER_LINK,
    infoLink: "/product-overview#central-service",
  },
  {
    title: (
      <>
        Station
        <br />
        Registry
      </>
    ),
    description:
      "Here you can see all the registered Stations and onboard your own.",
    label: "Visit the Station Registry",
    link: STATION_REGISTRY_LINK,
    infoLink: "",
  },
  {
    title: "Train Depot",
    description: "The train depot allows you to access PHT Trains codes.",
    label: "Visit the Train Depot",
    link: DEPOT_LINK,
    infoLink: "",
  },  
  // {
  //   title: "Train Creator",
  //   description: "The train creator allows you to build PHT Trains.",
  //   label: "Visit the Train Creator",
  //   link: CREATOR_LINK,
  //   infoLink: "/product-overview#train-creation-wizard",
  // },
  // {
  //   title: "Train Store",
  //   description: "The train store views all available PHT Trains.",
  //   label: "Visit the Train Store",
  //   link: STOREHOUSE_LINK,
  //   infoLink: "/product-overview#train-creation-wizard",
  // },
  // {
  //   title: "Playground",
  //   description: "Use the playground to simulate and test your execution.",
  //   label: "Visit the Playground",
  //   link: PLAYGROUND_LINK,
  //   infoLink: "",
  // },
  // {
  //   title: "Metadata Dashboard",
  //   description:
  //     "Here you can retrieve metadata about different components of the PHT, e.g., a currently running execution.",
  //   label: "Visit Metadata Dashboard",
  //   link: METADATA_DASHBOARD_LINK,
  //   infoLink: "/product-overview#pht-infrastructure",
  // },
  {
    title: "Schema",
    description: "Our metadata specification for the infrastructure.",
    label: "Visit the Schema",
    link: SCHEMA_LINK,
    infoLink: "",
  },
  {
    title: "Documentation",
    description: "Find detailed information about our components here.",
    label: "See the documentation",
    link: DOCUMENTATION_LINK,
    infoLink: "",
  },
];

const blogPosts = [
  {
    title: "MII Academy",
    date: "April 12, 2024",
    author: "Karl Kindermann",
    image: "./assets/blogs/mii-academy.png",
    smallWidth: true,
    description: (
      <>
        The <RenderLink href="https://www.medizininformatik-initiative.de/en/start" text="Medical Informatics Initiative (MII)"/> 
        has been establishing a number of processes to make data from healthcare available to research.
        With their new online learning portal MII-Academy they support researchers in using the services and processes created by the MII. 
        Video tutorials provide you with information and practical instructions on how to gain access to routine medical data 
        for your research projects, how to use it effectively and how to analyze it optimally.
        <br />
        <br />
        Visit the <RenderLink href="https://www.smith.care/en/education/mii-academy/mii-academy-structure-and-content/" text="MII Academy Website" /> for access and further information.
      </>
    ),
  },
  {
    title: "PADME at the SHIFT-HUB Online DemoDay",
    date: "March 23, 2024",
    author: "Karl Kindermann",
    image: "./assets/blogs/shifthub-demo.png",
    smallWidth: true,
    description: (
      <>
        On March 19<sup>th</sup>, we presented a live demo of PADME at the SHIFT-HUB Online DemoDay Cologne. 
        SHIFT-HUB aims at establishing a pan-European Smart Health Innovation Hub, to foster the uptake of Smart health Technologies and services. 
        During the event, we showcased the capabilities of PADME and how it can be used to conduct privacy-preserving data analysis. 
        The demo was well-received, and we received positive feedback from the audience. 
        We look forward to future collaborations with SHIFT-HUB and other partners.
        <br />
        <br />
        Find a video of the event on YouTube: <RenderLink href="https://youtu.be/tYSWjufZHS8?feature=shared" text="SHIFT-HUB Online DemoDay Cologne" />
      </>
    ),
  },
  {
    title: (
      <>
        18<sup>th</sup> Annual Meeting DGEpi 2023
      </>
    ),
    date: "October 9, 2023",
    author: "Sascha Welten",
    image: "./assets/projects/nfdi_health_squared.png",
    smallWidth: true,
    description: (
      <>
        From September 26<sup>th</sup>-28<sup>th</sup>, we participated in the
        yearly gathering of the German epidemiology community (DGEpi) held in{" "}
        <RenderLink href="https://2023.dgepi.de/" text="Würzburg" />.
        <br />
        <br />
        During one of the workshops, we introduced the idea and benefits of the
        Personal Health Train (PHT) using PADME. We showcased the ease of
        conducting data analyses and highlighted how PHT/PADME can foster
        collaborations among various institutions.
      </>
    ),
  },
  {
    title: "Station Software New User Interface Release",
    date: "October 5, 2023",
    author: "Muhammad Hamza Akhtar",
    image: "./assets/logo-black.png",
    smallWidth: true,
    description: (
      <>
        We are excited to announce the release of our new user interface for the
        Station Software. We've revamped our navigation to make finding what you
        need quicker and more intuitive. The new user interface is modern with a
        much cleaner layout that guides you seemlessly through our services.
        <br />
        <br />
        To get started, please visit our documentation page{" "}
        <RenderLink
          href="https://docs.padme-analytics.de/en/how-to/initial-station-setup#software-setup-new"
          text="here"
        />
        {". "}
        We hope you enjoy the new look and feel of the Station Software!
      </>
    ),
  },
  {
    title: "PADME at the NFDI4Health consortia meeting",
    date: "August 23, 2023",
    author: "Sven Weber",
    image: "./assets/projects/nfdi_health_squared.png",
    bigImage: "./assets/blogs/NFDI_Poster_Consortia_Meeting_Cologne_23.jpg",
    smallWidth: true,
    description: (
      <>
        On the 5th-7th of July 2023, the PADME team took part in the NFDI4Health
        consortia meeting in Cologne. During the meeting, the team presented a
        poster about joint work with Fraunhofer MEVIS on medical imaging AI. The
        poster describes how the Federated Learning (FL) extension of PADME,
        developed for NFDI4Health, was used in collaboration with MEVIS'
        competence in radiomics to conduct a Proof-of-Concept use case on
        privacy-preserving kidney tumor research. In the use case, we
        distributed open-source data from the{" "}
        <RenderLink href="https://kits19.grand-challenge.org/" text="KiTS19" />{" "}
        challenge to two sides and performed segmentation of the Kidney CT scans
        using{" "}
        <RenderLink
          href="https://totalsegmentator.com/"
          text="TotalSegmentator"
        />{" "}
        to distinguish the right and left kidney. From the segmentations, we
        extracted radiomics features, which provide an anonymous description of
        the CT's properties. Using PADME, we collected those features from the
        sides, combined them, and performed a cluster analysis to find
        correlations between the features and tumor cases from the dataset.
        <br />
        <br />
        The conduct of the use case demonstrates the capability of the PADME FL
        solution to enable privacy-preserving clinical research. Building on
        those capabilities and the established relationship between PADME and
        Fraunhofer MEVIS, we are currently pursuing additional clinical use
        cases in collaboration with the University Hospital Cologne.
        <br />
        <br />
        Pictures from the consortia meeting and further information can be found
        on the{" "}
        <RenderLink
          href="https://www.nfdi4health.de/en/news-eng/latest-news/item/228-nfdi4health-meeting-in-cologne.html"
          text="NFDI4Health website"
        />
        . Moreover, we will give a presentation on the described use case in the{" "}
        <RenderLink
          href="https://www.nfdi.de/cordi-2023/"
          text="CoRDI conference"
        />
        , where an extended abstract with the title "Distributed
        Privacy-Preserving Data Analysis in NFDI4Health with the Personal Health
        Train" was accepted. The poster from the consortia meeting can be found
        in the following:
      </>
    ),
  },
  {
    title:
      "Introducing PADME Conductor Beta: Streamlining the Analysis Development",
    date: "May 26, 2023",
    author: "Sascha Welten",
    image: "./assets/blogs/conductor.png",
    description: (
      <>
        We are happy to announce the introduction of the PADME Conductor
        library. By leveraging PADME Conductor's pre-built functions, developers
        can eliminate the need to write complex code from scratch, saving time
        and effort. This library offers a comprehensive toolkit for data
        processing, thereby allowing developers to focus on deriving valuable
        insights rather than grappling with technical complexities. The code of
        the library is{" "}
        <RenderLink
          href="https://github.com/sawelt/padme-conductor"
          text="available on GitHub"
        />{" "}
        and{" "}
        <RenderLink
          href="https://pypi.org/project/padme-conductor/"
          text="can be installed via pip in python."
        />{" "}
      </>
    ),
  },
  {
    title: "PADME in the SMITH News-Blog",
    date: "November 15, 2022",
    author: "Sascha Welten",
    image: "./assets/logo-black.png",
    smallWidth: true,
    description: (
      <>
        Our PADME infrastructure has been presented in the SMITH News-Blog. More
        information can be found{" "}
        <RenderLink href="https://www.smith.care/en/2022/11/15/" text="here." />{" "}
      </>
    ),
  },
  {
    title: "Talk at miracum-difuture colloquium",
    date: "October 31, 2022",
    author: "Sascha Welten",
    image: "./assets/logo-black.png",
    smallWidth: true,
    description: (
      <>
        We presented the current status of the implementation of PADME at the
        miracum-difuture-colloquium. You can find information about the
        presentation{" "}
        <RenderLink
          href="https://sites.google.com/master-bids.de/miracum-difuture-kolloquium/miracum-difuture-kolloquium/2022/2022-10-25-implementierung-des-personal-health-train-im-smith-projekt"
          text="here."
        />{" "}
        Read here more about{" "}
        <RenderLink
          href="https://www.miracum.org/2022/10/18/miracum-beim-jahressymposium-der-medizininformatik-initiative"
          text="miracum"
        />{" "}
        and <RenderLink href="https://difuture.de" text="difuture" />.
      </>
    ),
  },
  {
    title: "New Homepage & Landing page Launch",
    date: "July 1, 2022",
    author: "Sascha Welten",
    image: "./assets/logo-black.png",
    smallWidth: true,
    description:
      "Our new online presence has been launched! On this facelifted landing page, you can find infos about PADME and get access to our services.",
  },
  {
    title: "Accepted paper for Methods of Information in Medicine journal",
    date: "January 17, 2022",
    author: "Sascha Welten",
    image: "./assets/blogs/books.jpeg",
    description:
      "Our paper on A Privacy-Preserving Distributed Analytics Platform for Health Care Data will be published in the Methods of Information in Medicine journal.",
  },
  {
    title: "Prof. Beyan at Digital Health Europe Summit",
    date: "October 13, 2021",
    author: "Sascha Welten",
    image: "./assets/blogs/event.jpeg",
    description:
      "Prof. Beyan attended a panel on Distributed Analytics at the Digital Health Europe Summit . During this panel, experts discussed solutions for on-demand access to federated datasets and to cloud computing resources, and how these have the potential to accelerate the digital transformation of health and care (Ref: https://digitalhealtheurope.eu/dhe-summit/).",
  },
  {
    title: "Exploring new Domains",
    date: "October 7, 2021",
    author: "Sascha Welten",
    image: "./assets/blogs/lightning.jpeg",
    description:
      "For the next 12 months, we are exploring the applicability of PADME in an other domain beyond healthcare. As part of the SFC “AI, Simulation and Data Science”, we are going to explore the applicability of PADME in early warning systems for floods. Connecting multiple decentralised datasets for flood predictions might improve their reliability. Let's see what we can do there.",
  },
  {
    title: "Station Registry online!",
    date: "September 3, 2021",
    author: "Sascha Welten",
    image: "./assets/blogs/Building.jpeg",
    description: (
      <>
        We are happy to announce that we successfully linked our PADME ecosystem
        with the Station Registry from our partners in Mittweida/Leipzig. Now,
        the Station on-boarding process is semi-automated and the corresponding
        overhead is reduced significantly. The Station Registry can be found
        here:{" "}
        <RenderLink
          href="https://station-registry.de"
          text="https://station-registry.de"
        />
      </>
    ),
  },
  {
    title: "Accepted paper at PDFL workshop 2021",
    date: "August 18, 2021",
    author: "Yongli Mou",
    image: "./assets/blogs/event.jpeg",
    description:
      "Our paper Optimized Federated Learning on Class-biased Distributed Data Sources is accepted for presentation at the PDFL workshop 2021 in conjunction with ECML PKDD. The paper will be published in a combined volume ECML PKDD Workshops.",
  },
  {
    title: "Accepted paper for Data Intelligence journal",
    date: "May 10, 2021",
    author: "Sascha Welten",
    image: "./assets/blogs/books.jpeg",
    description:
      "Our paper DAMS: A Distributed Analytics Metadata Schema will be published in the Data Intelligence journal.",
  },
  {
    title: "Accepted Paper at MIE21",
    date: "May 5, 2021",
    author: "Sascha Welten",
    image: "./assets/blogs/event.jpeg",
    description:
      "Our paper Distributed Skin Lesion Analysis across Decentralised Data Sources has been accepted for MIE21.",
  },
  {
    title: "Re-deploy of PADME Central Service was successfull",
    date: "April 30, 2021",
    author: "Sascha Welten",
    image: "./assets/blogs/Building.jpeg",
    description: (
      <>
        The growth of our infrastructure forced us to re-structure our central
        server. All services are now accessible via our new web-portal:{" "}
        <RenderLink
          href="https://menzel.informatik.rwth-aachen.de:3005"
          text="https://menzel.informatik.rwth-aachen.de:3005"
        />
        <br />
        <br />
        Stay tuned!
      </>
    ),
  },
];

const teams = [
  {
    type: "Team Cologne University",
    active: true,
    members: [
      {
        name: "Prof. Dr. Oya Beyan",
        role: "HEAD",
        designation: "Chair Holder @Köln, Group Leader @FIT",
        image: "./assets/team/oya.jpeg",
        social: [
          {
            type: "Website",
            link: "http://oyabeyan.info",
            icon: <PublicIcon />,
          },
        ],
      },
      {
        name: "Mehrshad Jaberansary",
        role: "Research Assistant Uniklinik Köln",
        designation: "Computer Science @RWTH",
        image: "./assets/team/mehrshad.jpeg",
        social: [
          {
            type: "Email",
            link: "mailto:pht@dbis.rwth-aachen.de",
            icon: <EmailIcon />,
          },
        ],
      },
    ],
  },
  {
    type: "Team FIT",
    active: true,
    members: [
      {
        name: "Yeliz Ucer Yediel",
        role: "Software Engineer M.Sc.",
        designation: "Product Management @FIT",
        image: "./assets/team/yeliz.jpeg",
        social: [
          {
            type: "Email",
            link: "mailto:yeliz.ucer.yediel@fit.fraunhofer.de",
            icon: <EmailIcon />,
          },
          {
            type: "LinkedIn",
            link: "https://www.linkedin.com/in/yelizucer",
            icon: <LinkedInIcon />,
          },
        ],
      },
      {
        name: "Muhammad Hamza Akhtar",
        role: "Student Assistant",
        designation: "Data Science @RWTH",
        image: "./assets/team/hamza.jpg",
        social: [
          {
            type: "LinkedIn",
            link: "https://www.linkedin.com/in/mhamzaakhtar/",
            icon: <LinkedInIcon />,
          },
        ],
      },
      {
        name: "Sabith Haneef",
        role: "Student Assistant",
        designation: "Software Systems Engineering @RWTH",
        image: "./assets/team/sabith.jpg",
        social: [
          {
            type: "LinkedIn",
            link: "https://www.linkedin.com/in/sabith-t-h-21a29716b/",
            icon: <LinkedInIcon />,
          },
        ],
      },
    ],
  },
  {
    type: "Team Leipzig University",
    active: true,
    members: [
      {
        name: "Prof. Dr. Toralf Kirsten",
        role: "Contributor",
        designation: "Professor @Leipzig",
        image: "./assets/team/toralf.jpeg",
        social: [
          {
            type: "Email",
            link: "toralf.kirsten@medizin.uni-leipzig.de",
            icon: <EmailIcon />,
          },
          {
            type: "Website",
            link: "https://www.uniklinikum-leipzig.de/einrichtungen/medical-data-science",
            icon: <PublicIcon />,
          },
        ],
      },
      {
        name: "Masoud Abedi",
        role: "Machine & Deep Learning Methods",
        designation: "Ph.D Candidate @Leipzig",
        image: "./assets/team/masoud.jpeg",
        social: [
          {
            type: "Email",
            link: "mailto:masoud.abedi@medizin.uni-leipzig.de",
            icon: <EmailIcon />,
          },
          {
            type: "Website",
            link: "https://www.uniklinikum-leipzig.de/einrichtungen/medical-data-science",
            icon: <PublicIcon />,
          },
        ],
      },
      {
        name: "Maximilian Jugl",
        role: "Cyber Security",
        designation: "Ph.D Candidate @Leipzig",
        image: "./assets/team/maximilian.jpeg",
        social: [
          {
            type: "Email",
            link: "mailto:maximilian.jugl@medizin.uni-leipzig.de",
            icon: <EmailIcon />,
          },
          {
            type: "Website",
            link: "https://www.uniklinikum-leipzig.de/einrichtungen/medical-data-science",
            icon: <PublicIcon />,
          },
        ],
      },
      {
        name: "Lars Hempel",
        role: "Bioinformatics",
        designation: "Ph.D Candidate @Leipzig",
        image: "./assets/team/lars.jpeg",
        social: [
          {
            type: "Email",
            link: "mailto:lars.hempel@medizin.uni-leipzig.de",
            icon: <EmailIcon />,
          },
          {
            type: "Website",
            link: "https://www.uniklinikum-leipzig.de/einrichtungen/medical-data-science",
            icon: <PublicIcon />,
          },
        ],
      },
    ],
  },
  {
    type: "Team RWTH University",
    active: true,
    members: [
      {
        name: "Prof. Dr. Stefan Decker",
        role: "Director",
        designation: "Chair Holder @RWTH, Director @FIT",
        image: "./assets/team/decker.jpeg",
        social: [
          {
            type: "Email",
            link: "mailto:stefan.decker@fit.fraunhofer.de",
            icon: <EmailIcon />,
          },
        ],
      },
      {
        name: "Sascha Welten",
        role: "Computer Science M.Sc.",
        designation: "PhD Student @RWTH",
        image: "./assets/team/sascha.jpeg",
        social: [
          {
            type: "Email",
            link: "mailto:welten@dbis.rwth-aachen.de",
            icon: <EmailIcon />,
          },
          {
            type: "Website",
            link: "https://dbis.rwth-aachen.de/dbis/index.php/user/welten/",
            icon: <PublicIcon />,
          },
          {
            type: "LinkedIn",
            link: "https://www.linkedin.com/in/sascha-welten-040b32b2",
            icon: <LinkedInIcon />,
          },
        ],
      },
      {
        name: "Yongli Mou",
        role: "Computer Science M.Sc.",
        designation: "PhD Student @RWTH",
        image: "./assets/team/yongli.jpeg",
        social: [
          {
            type: "Email",
            link: "mailto:mou@dbis.rwth-aachen.de",
            icon: <EmailIcon />,
          },
          {
            type: "Website",
            link: "https://dbis.rwth-aachen.de/dbis/index.php/user/mou/",
            icon: <PublicIcon />,
          },
          {
            type: "LinkedIn",
            link: "https://www.linkedin.com/in/mouyongli/040b32b2",
            icon: <LinkedInIcon />,
          },
        ],
      },
      {
        name: "Karl Kindermann",
        role: "Student Assistant",
        designation: "Computer Science @RWTH",
        image: "./assets/team/karl.jpg",
        social: [
          {
            type: "Email",
            link: "mailto:karl.kindermann@rwth-aachen.de",
            icon: <EmailIcon />,
          },
          {
            type: "LinkedIn",
            link: "https://www.linkedin.com/in/karlkindermann/",
            icon: <LinkedInIcon />,
          }
        ]
      }
    ],
  },
  {
    type: "Alumni",
    active: false,
    members: [
      {
        name: "Laurenz Neumann",
        role: "Student Assistant",
        designation: "Computer Science @RWTH",
        image: "./assets/team/laurenz.jpeg",
        social: [
          {
            type: "Email",
            link: "mailto:pht@dbis.rwth-aachen.de",
            icon: <EmailIcon />,
          },
        ],
      },
      {
        name: "Sven Weber",
        role: "Research Assistant Uniklinik Köln",
        designation: "Master Student @ETH Zürich",
        image: "./assets/team/sven.jpeg",
        social: [
          {
            type: "LinkedIn",
            link: "https://de.linkedin.com/in/sven-weber-265736148",
            icon: <LinkedInIcon />,
          },
        ],
      },
      {
        name: "Hauke Heidemeyer",
        role: "Student Assistant",
        designation: "Computer Science @RWTH",
        image: "./assets/team/heidemeyer.jpeg",
        social: [
          {
            type: "Email",
            link: "mailto:pht@dbis.rwth-aachen.de",
            icon: <EmailIcon />,
          },
        ],
      },
    ],
  },
];

export { blogPosts, teams, features };
